import {
  CLEAR_PROJECT_ERROR,
  FETCH_TENANTS_BY_PROJECT_REQUEST,
  FETCH_TENANTS_BY_PROJECT_SUCCESS,
  FETCH_TENANTS_BY_PROJECT_FAILURE,
  CLEAR_TENANTS_DATA,
  SET_CURRENT_PROJECT,
  CLEAR_CURRENT_PROJECT
} from '../../actions/projectsActions';

const initialState = {
  selectedProject: null,
  tenants: [],
  tenantsLoading: false,
  tenantsError: null,
  tenantsPagination: {
    totalElements: 0,
    totalPages: 0,
    currentPage: 1,
    pageSize: 10,
    hasNextPage: false,
    hasPreviousPage: false,
    searchTerm: ''
  }
};

const currentProject = (state = initialState, action) => {
  switch (action.type) {
    case CLEAR_PROJECT_ERROR:
      return {
        ...state,
        tenantsError: null
      };

    case SET_CURRENT_PROJECT:
      return {
        ...state,
        selectedProject: action.payload
      };

    case CLEAR_CURRENT_PROJECT:
      return {
        ...state,
        selectedProject: null
      };

    // Tenant-related cases
    case FETCH_TENANTS_BY_PROJECT_REQUEST:
      return {
        ...state,
        tenantsLoading: true,
        tenantsError: null
      };

    case FETCH_TENANTS_BY_PROJECT_SUCCESS:
      return {
        ...state,
        tenantsLoading: false,
        tenantsError: null,
        tenants: action.payload.items || action.payload.tenants || action.payload,
        tenantsPagination: {
          totalElements: action.payload.totalCount || 0,
          totalPages: action.payload.totalPages || 1,
          currentPage: action.payload.pageNumber || 1,
          pageSize: action.payload.pageSize || 10,
          hasNextPage: action.payload.hasNextPage || false,
          hasPreviousPage: action.payload.hasPreviousPage || false,
          searchTerm: action.payload.searchTerm || ''
        }
      };

    case FETCH_TENANTS_BY_PROJECT_FAILURE:
      return {
        ...state,
        tenantsLoading: false,
        tenantsError: action.payload,
        tenants: []
      };

    case CLEAR_TENANTS_DATA:
      return {
        ...state,
        tenants: [],
        tenantsError: null,
        tenantsLoading: false,
        tenantsPagination: {
          totalElements: 0,
          totalPages: 0,
          currentPage: 1,
          pageSize: 10,
          hasNextPage: false,
          hasPreviousPage: false,
          searchTerm: ''
        }
      };

    default:
      return state;
  }
};

export default currentProject;
